module.exports = __webpack_public_path__ + "img/brotas.a56cc60d.png";